var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ApplicationList"},[_c('application-section',{attrs:{"app-types":_vm.applicationTypes,"title":_vm.$t('ApplicationsList_Apps')}}),_vm._v(" "),_c('application-section',{attrs:{"app-types":_vm.websiteTypes,"title":_vm.$t('ApplicationsList_Websites')}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-556ef15b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/account/components/ApplicationList.vue
// module id = null
// module chunks = 